var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "panel-tag mt-2" }, [
      _vm._v(
        "\n        " + _vm._s(_vm.__t("GLOVO_LOCATION_PARAMS")) + "\n    "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {},
      [
        _c(
          "label",
          { staticClass: "form-label", attrs: { for: "glovo_location" } },
          [_vm._v(_vm._s(_vm.__t("GLOVO_LIST")))]
        ),
        _vm._v(" "),
        _c("v-select", {
          staticClass: "imc_reasons",
          attrs: {
            reduce: function (item) {
              return item.id
            },
            label: "username",
            options: this.auth_ext,
          },
          on: { input: _vm.get_locations },
          scopedSlots: _vm._u([
            {
              key: "option",
              fn: function (option) {
                return [
                  _c("div", { staticClass: "d-center" }, [
                    _c("div", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(option.username) +
                          " - " +
                          _vm._s(option.id) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                ]
              },
            },
          ]),
          model: {
            value: _vm.general_fields.ext_id,
            callback: function ($$v) {
              _vm.$set(_vm.general_fields, "ext_id", $$v)
            },
            expression: "general_fields.ext_id",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group form-group mt-4 pb-4" },
      [
        _c("b-overlay", { attrs: { show: _vm.is_load } }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "glovo_location" } },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.__t("GLOVO_REST")) +
                  "*\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.ext_restaurants.length > 0
            ? _c(
                "div",
                {},
                [
                  _c("v-select", {
                    staticClass: "imc_reasons",
                    attrs: {
                      reduce: function (item) {
                        return item.id
                      },
                      label: "address",
                      filter: _vm.searchRest,
                      options: this.ext_restaurants,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "option",
                          fn: function (option) {
                            return [
                              _c("div", { staticClass: "d-center" }, [
                                _c("div", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(option.id) +
                                      " - " +
                                      _vm._s(option.address) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3875801251
                    ),
                    model: {
                      value: _vm.general_fields.store_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.general_fields, "store_id", $$v)
                      },
                      expression: "general_fields.store_id",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }